import supabase from "./supabase";

interface CreateClassParams {
  name: string;
  description?: string;
  semester: string;
  createJoinCode: boolean;
  settings: {
    class_time: string;
    reflection_requirements?: {
      min_words?: number;
      min_sentences?: number;
      enabled: boolean;
    };
  };
  grade_type: string;
}

export async function createClass(data: CreateClassParams): Promise<{
  error: string | null;
}> {
  try {
    const { error } = await supabase.functions.invoke("createClass", {
      body: data,
    });

    if (error) {
      console.error("Error creating class:", error);
      return { error: error.message };
    }

    return { error: null };
  } catch (err: any) {
    console.error("Error creating class:", err);
    return { error: err.message };
  }
}
